import React from 'react';
import PostPage from '../../containers/PostPage';

export default function App() {
  return <PostPage/>
}
